import { FC } from "react";
import { LicenseInfo } from "@mui/x-license-pro";
import { ThemeProvider } from "@mui/material/styles";

import "./App.css";
import { RootState } from "./app/store";
import { theme } from "./shared/theme";
import { useAppSelector } from "./app/hooks";
import AppRouter from "./app/router";
import Loader from "./features/components/loader";
import ValidationDialog from "./features/components/validation-dialog";
import ErrorDialog from "./features/components/error-dialog";
import WarningAcknowledgmentDialog from "./features/components/warning-acknowledgment-dialog";

LicenseInfo.setLicenseKey(
  "98924a81f2580b88a0ae6e512404b48bTz0xMzEzMzMsRT0xODE2NTU5OTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMS0yMDI2LFE9MTcsS1Y9Mg==",
);

const App: FC = () => {
  const appLoading = useAppSelector((state: RootState) => state.app.loading);
  const matterLoading = useAppSelector(
    (state: RootState) => state.matter.loading
  );

  return (
    <ThemeProvider theme={theme}>
      {(appLoading || matterLoading) && <Loader overlay />}
      <AppRouter />
      <ValidationDialog />
      <ErrorDialog />
      <WarningAcknowledgmentDialog />
    </ThemeProvider>
  );
};

export default App;
